import React from 'react';
import styled from 'styled-components';

import LinkClickable from 'components/basic/Link/LinkClickable';
import { staticDispatch } from 'reduxState/store';
import { showWalletNonDelegatedModal } from 'reduxState/wallet/walletDetailsReducer';

import UnlockWalletButton from '../UnlockWalletButton';

const Wrap = styled.div`
  padding-top: 80px;
  text-align: center;
  line-height: 4;
`;

export default function UnlockChoiceButtons() {
  return (
    <Wrap>
      <UnlockWalletButton inline widePadding />
      <br />
      <LinkClickable
        onClick={() => staticDispatch(showWalletNonDelegatedModal())}
      >
        Connect Wallet Without a Session Key
      </LinkClickable>
    </Wrap>
  );
}
